import React, { useState, useLayoutEffect } from 'react';

import EquipmentScheduleOrder from './EquipmentScheduleOrder';
import SnackBar from '../../components/SnackBar';
import equipmentScheduleOrderPageActions from 'store/equipment/equipmentScheduleOrderPageActions';
import { useDispatch } from 'react-redux';
import { getLocations } from 'store/settings/settingsOperations';

const EquipmentScheduleOrderWrapper = () => {
  const dispatch = useDispatch()
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    text: '',
    type: 'success',
  });

  useLayoutEffect(() => {
    dispatch(getLocations());
    dispatch(
      equipmentScheduleOrderPageActions.getEquipmentScheduleOrdersData({
        colorGroups: {},
        equipmentOrderInColorGroups: {},
      })
    );
  }, []);

  const openSnackbar = (type, text) => setSnackbar({ isOpen: true, type, text });

  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, isOpen: false }));

  return (
    <>
      <EquipmentScheduleOrder openSnackbar={openSnackbar} />
      <SnackBar closeSnackbar={closeSnackbar} {...snackbar} />
    </>
  );
};

export default EquipmentScheduleOrderWrapper;
